module.exports = __webpack_public_path__ + "img/migros-giftcard.155a8b0d.svg";